/** @format */

import React, { useState, useEffect } from "react";
import Link from "next/link";
// import useSettings from "stores/settings";
// import { useRouter } from "next/router";
import { observer } from "mobx-react-lite";
import Paginations from "components/Paginations";
// import { PreviewStorageUrl } from "components/PreviewStorageUrl";
// import AppLikeCount from "components/AppLikeCount";
import UserPhoto from "components/UserPhoto";
import UserName from "components/UserName";
import { projectFirestore } from "components/ProjectFirestore";
import { DateDescendingOrder, DateAscendingOrder, UseCountDescendingOrder } from "components/Function";
// Modal
import IconButton from "@material-ui/core/IconButton";
import ShareIcon from "@material-ui/icons/Share";

import ShareModal from "components/modal/ShareModal";

// Search
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
// DotMenu
import MenuItem from "@material-ui/core/MenuItem";

import SkeletonDataAnalysis from "components/skeleton/SkeletonDataAnalysis";

const AllDataAnalysisList = observer(({ category }) => {
  const [loading, setLoading] = useState(true);

  /* 페이지네이션 */
  const [pageOfItems, setPageOfItems] = useState([]);
  const [startIndex, setStartIndex] = useState(0);
  // const [page, setPage] = useState(settings.aisoMarketPage);
  const [page] = useState(1);

  const [contentsData, setContentsData] = useState(null);
  // const [dataAnalysisDatas, setDataAnalysisDatas] = useState(null);

  /* 검색 관련 데이터 */
  const [selectMenu, setSelectMenu] = useState("use");
  const [searchData, setSearchData] = useState("");

  useEffect(async () => {
    try {
      const datas = [];
      const collectionRef = projectFirestore.collection("market").doc("public").collection("app");

      const collectionValue = await collectionRef.get();
      collectionValue.forEach((doc) => {
        /* 완성되지 않은 앱은 목록에서 제거 */
        if (doc.data().status === "앱 배포완료" && doc.data().visible && doc.data().category === "dataAnalysis") {
          datas.push({ ...doc.data() });
        }
      });

      /* 검색 필터 */
      let tempDatas = datas.sort(DateDescendingOrder);
      // setDataAnalysisDatas(tempDatas);

      /* 앱 ORDER BY  - 기본 new */
      if (selectMenu === "recommend") {
        /* 우선 내림 차순으로 넣어놨는데 나중에 추천으로 바꿔야함. */
        tempDatas.sort(DateDescendingOrder);
      }

      if (selectMenu === "use") {
        tempDatas.sort(UseCountDescendingOrder);
      }

      if (selectMenu === "old") {
        tempDatas.sort(DateAscendingOrder);
      }

      tempDatas = tempDatas.filter(
        (f) => f.appName.indexOf(searchData) !== -1 || f.email.indexOf(searchData) !== -1 || f.userName.indexOf(searchData) !== -1
      );
      if (category === "all") {
        setContentsData(tempDatas);
      } else if (category === "데이터분석") {
        setContentsData(tempDatas.slice(1));
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }, [category, searchData, selectMenu]);

  /* 페이지네이션 */
  const onChangePage = (pageOfItems, startIndex) => {
    setPageOfItems(pageOfItems);
    setStartIndex(startIndex);
  };

  return (
    <div>
      <SearchArea selectMenu={selectMenu} setSelectMenu={setSelectMenu} setSearchData={setSearchData} />
      {loading ? (
        Array.from({ length: 4 }).map((m, i) => {
          return <SkeletonDataAnalysis key={i} />;
        })
      ) : contentsData && contentsData.length > 0 ? (
        <div className="w-full">
          <div className="row">
            <div className="col-12 py-3 sm:py-0">
              {pageOfItems.map((m, index) => (
                <MarketCard {...m} key={startIndex + index} />
              ))}
            </div>
          </div>
          <Paginations items={contentsData} onChangePage={onChangePage} nowPage={page} />
        </div>
      ) : (
        <div className="center w-full py-32">
          {/* <div>Loading...</div> */}
          <div>등록된 앱이 없습니다.</div>
        </div>
      )}
    </div>
  );
});

/* Card Component */
const MarketCard = ({ appId, email, appName, price, createdAt, oneLineContent, useCount, imageUrl }) => {
  /* preview 가져오기 */
  /* 사용자 프로필 가져오기 */
  const photoUrl = UserPhoto(email);
  const name = UserName(email);
  //   /* 좋아요 수 체크 */
  //   const likeCount = AppLikeCount(email, appId);

  /* Modal */
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="w-full mb-4">
      <div className="h-full flex flex-col sm:flex-row items-center aiso-data-card">
        <Link
          href={{
            pathname: "/user/dataAnalysis/[id]",
            query: {
              id: appId,
            },
          }}
        >
          <div className="w-full min-h-full sm:w-4/12 md:w-3/12 xl:w-2/12 cursor-pointer">
            <div className="img-cover-box data-img-radius">
              <img src={imageUrl ? PreviewStorageUrl(imageUrl) : "/images/market/no-img.png"} />
            </div>
          </div>
        </Link>
        <div className="w-full h-full sm:w-8/12 md:w-9/12 xl:w-10/12 flex flex-col justify-between">
          <div className="w-full flex justify-between items-center px-3">
            <Link
              href={{
                pathname: "/user/dataAnalysis/[id]",
                query: {
                  id: appId,
                },
              }}
            >
              <div className="w-full px-3 cursor-pointer">
                <p className="truncate-2-lines text-333 text-xl font-bold mt-4">{appName}</p>
                <div className="truncate-1-lines text-333 text-base mt-2">
                  <div dangerouslySetInnerHTML={{ __html: oneLineContent }} />
                </div>
                <div className="w-full flex justify-between items-end mt-4 mb-3">
                  <p className="text-black text-base">{useCount ? useCount : "0"} 회 사용</p>
                  <p className="text-black text-base font-bold">{price} Credit</p>
                </div>
              </div>
            </Link>
          </div>
          <div className="w-full flex justify-between items-end px-3 py-2 data-card-footer">
            <div className="w-full flex justify-between items-center">
              <Link
                href={{
                  pathname: "/user/profile/[id]",
                  query: {
                    id: email,
                  },
                }}
              >
                <div className="flex justify-start items-center whitespace-pre-line break-all">
                  <div>
                    <div className="img-cover-box w-11 h-11 rounded-full bg-white border-2 border-white">
                      <img src={photoUrl} alt="profile" />
                    </div>
                  </div>
                  <div className="ml-2">
                    <p className="truncate-1-lines mb-0 text-black font-gmarket-medium text-sm">{name}</p>
                    <p className="mb-0 text-333 font-gmarket-medium text-xs">{createdAt.substring(0, 16)}</p>
                  </div>
                </div>
              </Link>
              <div className="z-50 px-3 ">
                <IconButton color="primary" onClick={handleOpen}>
                  <ShareIcon className="text-black" />
                </IconButton>
                <ShareModal
                  open={open}
                  handleClose={handleClose}
                  path={`/user/dataAnalysis/${appId}`}
                  title={appName}
                  description={oneLineContent}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

/* Search Area */
const SearchArea = ({ selectMenu, setSelectMenu, setSearchData }) => {
  const handleChange = (event) => {
    setSelectMenu(event.target.value);
  };
  return (
    <div className="w-full">
      <div className="row">
        <div className="col-12 col-sm-8 col-md-9 col-xl-10 mb-3">
          <Autocomplete
            id="free-solo-demo"
            freeSolo
            options={[]}
            className="search-input"
            renderInput={(params) => {
              setSearchData(params.inputProps.value);
              return <TextField {...params} margin="normal" variant="outlined" placeholder="Search" />;
            }}
          />
        </div>
        <div className="col-12 col-sm-4 col-md-3 col-xl-2 mb-3">
          <FormControl variant="outlined" className="search-input">
            <Select
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              onChange={handleChange}
              displayEmpty
              value={selectMenu}
            >
              <MenuItem value="new">최신순</MenuItem>
              {/* <MenuItem value="recommend">추천순</MenuItem> */}
              <MenuItem value="use">사용횟수순</MenuItem>
              <MenuItem value="old">오래된순</MenuItem>
            </Select>
          </FormControl>
        </div>
      </div>
    </div>
  );
};
export default AllDataAnalysisList;

const PreviewStorageUrl = (previewInput) => {
  let previewInputFile = "/images/market/no-img.png";
  if (previewInput)
    previewInputFile =
      "https://firebasestorage.googleapis.com/v0/b/aiso-api.appspot.com/o/" + encodeURIComponent(previewInput) + "?alt=media";

  return previewInputFile;
};
